import { useCallback, useState, type SetStateAction } from "react";
import { getCartQuantityStep, normalizePieceQuantity } from "@/lib/product-units";

export function useProductQuantity(conditioning: unknown, initialQuantity?: number) {
  const [requestedQuantity, setRequestedQuantity] = useState(initialQuantity ?? getCartQuantityStep(conditioning));
  // Product metadata may arrive after the first render. Never expose the stale
  // loading default to either the display or an add-to-cart handler.
  const quantity = normalizePieceQuantity(requestedQuantity, conditioning);
  const setQuantity = useCallback((update: SetStateAction<number>) => {
    setRequestedQuantity((previous) => normalizePieceQuantity(
      typeof update === "function" ? update(normalizePieceQuantity(previous, conditioning)) : update,
      conditioning
    ));
  }, [conditioning]);
  return [quantity, setQuantity] as const;
}
